/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback, useEffect, useRef, useState } from "react";
import Headroom from "react-headroom";
import { window } from "browser-monads";
import { useTranslation } from "react-i18next";
import { defaultLanguage } from "../../constants/languages";
import Conditional from "../../hocs/Conditional";
import useMediaQuery from "../../hooks/useMediaQuery";
import Icon from "../Icon";
import Image from "../Image";
import Link from "../Link";
import CreateAccountCtaMap from "./CreateAccountCta";
import StickyCtaBtn from "./CreateGettingStart";
import SignInHeaderMap from "./SignInHeader";
import { MENU_DATA } from "./constants";
import { SingleMenu, MultiOptionMenu, MainMenuOption } from "./Components";
import "./Header.scss";
import SalesPopup from "../SalesPopup";

const Header = ({ lightHeader, location }) => {
  const navRef = useRef();

  const { i18n, t } = useTranslation();
  const { language } = i18n;
  const show = t("isVisible");

  const isMobile = useMediaQuery("(max-width: 1200px)");

  const hideForGrowthPG = location?.pathname === "/growth/payment-gateway/";
  const hideForGrowthOneClickCheck =
    location?.pathname === "/growth/one-click-checkout/";

  const [dropdownOverlay, setDropdownOverlay] = useState(false);
  const [screenOverlay, setScreenOverlay] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const [mobileSubDropdownOpen, setmobileSubDropdownOpen] = useState(false);
  const [mainMenuOpen, setMainMenuOpen] = useState(false);
  const [hrefValue, setHref] = useState("");
  const [signInHref, setSignInHref] = useState("");
  const [stickyHref, setStickyHref] = useState("");
  const [hideMainScroll, setHideMainScroll] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [showBanner, setShowBanner] = useState(1);

  const bannerClass = isMobile
    ? ""
    : showBanner === 1
    ? "show-banner"
    : "hide-banner";

  const overlayClass = isMobile
    ? ""
    : showBanner === 1
    ? "overlay-with-banner"
    : "overlay-without-banner";

  const navBarClass = `${showBanner === 1 ? "show" : "hide"}-nav-bar-${
    lightHeader ? "dark" : "light"
  }`;

  const onMouseEnterSubMenu = (id) => {
    setHideMainScroll(true);
    setCurrentId(id);
  };

  const onMouseLeaveSubMenu = (id) => {
    setTimeout(() => {
      if (id === currentId) {
        setHideMainScroll(false);
      }
    }, 300);
  };

  const mainMenuOpenToggle = useCallback(() => {
    setMainMenuOpen((prevState) => !prevState);
    setMobileDropdownOpen(false);
    setDropdownOverlay((prevState) => !prevState);
  }, []);

  const dropdownOverlayHover = (value) => {
    if (!isMobile) {
      setScreenOverlay(value);
    }
  };

  const handleMouseEvents = useCallback(() => {
    const pElement = document.querySelector(".alert_strip");
    if (!pElement) {
      console.error("Element with class 'alert_strip' not found");
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const position = entries[0].intersectionRatio;
      setShowBanner(position);
    });
    observer.observe(pElement);
  }, [showBanner]);

  const mobileDropdownOpenclick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setMobileDropdownOpen((state) => (state === value ? null : value));
  });

  const mobileSubDropdownOpenclick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setmobileSubDropdownOpen((state) => (state === value ? null : value));
  });

  const appendLanguageToLink = (navigateTo) => {
    const updatedLink =
      language === defaultLanguage
        ? `${navigateTo}`
        : `/${language}${navigateTo}`;
    return updatedLink;
  };

  const setHrefBasedOnPath = (map, setter) => {
    const { pathname } = window.location;
    const allKeys = [...map.keys()];
    const requiredKey =
      pathname === "/"
        ? "_default"
        : allKeys.find((key) => pathname.includes(key)) || "_default";
    setter(map.get(requiredKey));
  };

  useEffect(() => {
    setHrefBasedOnPath(CreateAccountCtaMap, setHref);
    setHrefBasedOnPath(SignInHeaderMap, setSignInHref);
    setHrefBasedOnPath(StickyCtaBtn, setStickyHref);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      handleMouseEvents();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleMouseEvents]);

  return (
    <>
      <div>
        {/* <Conditional if={!hideForGrowthPG}>
          <Banner />
        </Conditional> */}
        <nav
          ref={navRef}
          className={`nav ${
            dropdownOverlay ? " body-overlay" : ""
          } ${navBarClass}`}>
          <Headroom
            disableInlineStyles
            onUnpin={() => setDropdownOverlay(true)}>
            <a
              href={
                hideForGrowthPG
                  ? "/growth/payment-gateway/"
                  : hideForGrowthOneClickCheck
                  ? "/growth/one-click-checkout/"
                  : appendLanguageToLink("/")
              }
              className="logo">
              <Image
                src="https://cashfreelogo.cashfree.com/website/landings-cache/landings/logo-lightbg_3x.webp"
                className="dark-logo"
                width="150"
                height="48"
                alt="cashfree"
                loading="eager"
              />

              <Image
                src="https://cashfreelogo.cashfree.com/website/landings-cache/landings/logo-lightbg_3x.webp"
                className="white-logo"
                width="150"
                height="48"
                alt="cashfree"
                loading="eager"
              />
            </a>
            <a
              href={stickyHref}
              className="button StickyCta border-none w-16 !rounded-[10px]">
              Get Started
            </a>

            <div
              className={`row justify-space-between menu ${
                mainMenuOpen ? "menu-open" : ""
              }`}>
              <button
                type="button"
                className="hamburger"
                aria-label="Open menu"
                onClick={mainMenuOpenToggle}>
                <span />
              </button>
              <div className={`row main-menu ${bannerClass}`}>
                <div className="row row-no-margin nav-mob-logo ">
                  <div className="visible-mobile">
                    <a
                      href={
                        hideForGrowthPG
                          ? "/growth/payment-gateway/"
                          : hideForGrowthOneClickCheck
                          ? "/growth/one-click-checkout/"
                          : "/"
                      }
                      style={{ padding: 0, border: "none" }}>
                      <Image
                        src="https://cashfreelogo.cashfree.com/website/landings-cache/landings/logo-lightbg_1x.webp"
                        width="120"
                        height="38"
                        alt="cashfree"
                      />
                    </a>
                  </div>

                  <button
                    type="button"
                    className="hamburger close"
                    aria-label="Close menu"
                    onClick={mainMenuOpenToggle}>
                    <span />
                  </button>
                </div>

                <Conditional
                  if={!hideForGrowthPG && !hideForGrowthOneClickCheck}>
                  {/* New Menu Changes */}
                  {MENU_DATA?.map(
                    ({
                      id,
                      mainmenu,
                      options,
                      isMenuVisibleByDefault,
                      showDefaultSubMenu,
                      subOptions,
                    }) => {
                      const menuOptions =
                        isMobile && showDefaultSubMenu
                          ? [...options, ...subOptions]
                          : options;
                      return (
                        <Conditional if={isMenuVisibleByDefault || show}>
                          <React.Fragment key={id}>
                            <Conditional if={options?.length > 1}>
                              <div
                                className={`dropdown has-side-menu ${
                                  mobileDropdownOpen === id
                                    ? "mob-dropdown-show"
                                    : ""
                                }`}
                                onMouseEnter={() => {
                                  onMouseEnterSubMenu(id);
                                  dropdownOverlayHover(true);
                                }}
                                onMouseLeave={() => {
                                  onMouseLeaveSubMenu(id);
                                  dropdownOverlayHover(false);
                                }}>
                                <a
                                  href="#!"
                                  onClick={mobileDropdownOpenclick(id)}>
                                  {mainmenu}
                                </a>
                                <div
                                  className={`dropdown-menu ${
                                    subOptions?.length > 0
                                      ? "side-dropdown"
                                      : ""
                                  } ${bannerClass}  ${
                                    !isMobile && subOptions?.length > 0
                                      ? "border-multi-menu"
                                      : "border-single-menu"
                                  }`}>
                                  <button
                                    onClick={mobileDropdownOpenclick(id)}
                                    type="button"
                                    className="go-back-nav">
                                    <Icon name="chevronright" /> Main Menu
                                  </button>
                                  <div
                                    className={`has-submenu ${
                                      hideMainScroll ? "hide-scrollbar" : ""
                                    } ${
                                      !isMobile && subOptions?.length > 0
                                        ? "border-multi-menu"
                                        : "border-single-menu"
                                    }`}>
                                    {menuOptions?.map(
                                      ({
                                        pageId,
                                        label,
                                        iconSrc,
                                        description,
                                        stylingClass,
                                        url,
                                        submenu,
                                        isSubOption,
                                        isOptionVisibleByDefault,
                                      }) => (
                                        <Conditional
                                          if={isOptionVisibleByDefault || show}>
                                          <div className="subdropdown">
                                            <MainMenuOption
                                              showDefaultSubMenu={
                                                showDefaultSubMenu
                                              }
                                              url={
                                                showDefaultSubMenu
                                                  ? url
                                                  : submenu?.length > 0
                                                  ? "#!"
                                                  : url
                                              }
                                              label={label}
                                              description={description}
                                              stylingClass={stylingClass}
                                              iconSrc={iconSrc}
                                              isSubOption={isSubOption}
                                              mobileSubDropdownOpenclick={
                                                !showDefaultSubMenu &&
                                                submenu?.length > 0
                                                  ? mobileSubDropdownOpenclick(
                                                      pageId,
                                                    )
                                                  : undefined
                                              }
                                              onMouseEnterSubMenu={() => {
                                                onMouseEnterSubMenu(pageId);
                                                dropdownOverlayHover(true);
                                              }}
                                              onMouseLeave={() => {
                                                onMouseLeaveSubMenu(pageId);
                                                dropdownOverlayHover(false);
                                              }}
                                              submenu={submenu}
                                            />
                                            <Conditional
                                              if={subOptions?.length > 0}>
                                              <Conditional
                                                if={
                                                  !showDefaultSubMenu &&
                                                  !submenu
                                                }>
                                                {/* SingleMenu component */}
                                                <SingleMenu
                                                  key={pageId}
                                                  iconSrc={iconSrc}
                                                  label={label}
                                                  description={description}
                                                  url={url}
                                                  bannerClass={bannerClass}
                                                />
                                              </Conditional>
                                              <Conditional
                                                if={
                                                  showDefaultSubMenu ||
                                                  submenu?.length > 0
                                                }>
                                                <div
                                                  className={`${
                                                    !isMobile
                                                      ? "border-div side-dropdown subdropdown-menu-side"
                                                      : ""
                                                  } dropdown-menu subdropdown-menu  ${
                                                    !isMobile
                                                      ? "border-bottom-right"
                                                      : ""
                                                  } ${
                                                    mobileSubDropdownOpen ===
                                                    pageId
                                                      ? "submenu-open"
                                                      : ""
                                                  } ${bannerClass}`}>
                                                  <button
                                                    onClick={mobileSubDropdownOpenclick(
                                                      pageId,
                                                    )}
                                                    type="button"
                                                    className="go-back-nav">
                                                    <Icon name="chevronright" />{" "}
                                                    {label}
                                                  </button>
                                                  {/* MultiOptionMenu component */}
                                                  <MultiOptionMenu
                                                    submenu={
                                                      showDefaultSubMenu
                                                        ? subOptions
                                                        : submenu
                                                    }
                                                    isMobile={isMobile}
                                                  />
                                                </div>
                                              </Conditional>
                                            </Conditional>
                                          </div>
                                        </Conditional>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Conditional>
                            <Conditional if={options?.length === 1}>
                              <Link
                                to={options?.[0]?.url}
                                className="partner-nav">
                                {mainmenu}
                              </Link>
                            </Conditional>
                          </React.Fragment>
                        </Conditional>
                      );
                    },
                  )}
                  {/* New Menu Changes */}
                </Conditional>
                <Conditional if={!!show}>
                  <a href={signInHref} className="visible-1200">
                    Sign in
                  </a>

                  <div className="mob-sign-in visible-1200">
                    <a href={hrefValue} className="button button-purple">
                      Create Account <span className="chevron" />
                    </a>
                  </div>
                </Conditional>
              </div>

              <Conditional if={!!show}>
                <div className="pricing-desktop">
                  <a href={signInHref}>Sign in</a>
                  <a
                    href={hrefValue}
                    className="button sign-in-button font-inter"
                    style={{ display: "inline-flex", alignItems: "center" }}>
                    Create Account
                    <Icon name="chevronright" />
                  </a>
                </div>
              </Conditional>
            </div>
          </Headroom>
        </nav>
      </div>
      <div
        className={`${
          screenOverlay ? "overlay-navbar" : "overlay-nav"
        } ${overlayClass}`}
      />
      <SalesPopup />
    </>
  );
};

export default Header;
